import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import AdminPanelSettings from '@mui/icons-material/AdminPanelSettings';
import AboutIcon from '@mui/icons-material/Info';
import FolderIcon from '@mui/icons-material/Folder';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';

import { changePage } from '../../actions'
import React from 'react'
import { useDispatch } from 'react-redux'
import { conf, RouteConf, ComponentConf } from 'src/config'
import * as routes from '../../routes'
import { isArray } from 'lodash';
import { globalProps } from 'src/config'
import LeftDrawer from '../components/LeftDrawer';
import { getPrincipal, AccessLevel, Principal } from 'src/auth';
import { getLabel } from './utils'
import _ from 'lodash';


const ItemIcon: React.FC<{ rtConf: RouteConf }> = ({ rtConf }) => {
    const compConf: ComponentConf | ComponentConf[] = rtConf.comp;
    let icon = <FolderIcon />

    if (!isArray(compConf)) {
        if (compConf.type === 'entity') {
            icon = <CreateNewFolderIcon />
        }
    }

    return icon;
}

const PublicMenu: React.FC = () => {
    const dispatch = useDispatch()
    const principal: Principal = getPrincipal();

    const userUiRoutes = _.pickBy(conf.getUiRoutes(), (value, key) => {
        return principal.hasAccess(value.comp, AccessLevel.Read);
    });

    const paths: string[] =
        Object.keys(userUiRoutes)
            .filter(path => path.indexOf(':') === -1);



    const handleNavigate = (pathName: string) => (e: React.SyntheticEvent) => {
        dispatch(changePage(pathName));
    }

    return (
        <LeftDrawer>
            <Box sx={{ overflow: 'auto' }}>
                {(principal.root || globalProps.isDebug()) && <>
                    <List>
                        <ListItemButton onClick={handleNavigate(routes.ROUTEADMIN)}>
                            <ListItemIcon>
                                <AdminPanelSettings />
                            </ListItemIcon>
                            <ListItemText primary={'Admin Console'} />
                        </ListItemButton>
                    </List>
                    <Divider />
                </>}

                {
                    paths.length > 0 && <>
                        <List>
                            {
                                paths.map((path, index) =>
                                    <ListItemButton key={index} onClick={handleNavigate(path)}>
                                        <ListItemIcon>
                                            <ItemIcon rtConf={userUiRoutes[path]} />
                                        </ListItemIcon>
                                        <ListItemText primary={getLabel(userUiRoutes[path])} />
                                    </ListItemButton>
                                )
                            }
                        </List>
                        <Divider />
                    </>
                }

                <List>
                    {/* <ListItemButton onClick={handleNavigate(routes.ROUTEABOUT)}>
                        <ListItemIcon>
                            <AboutIcon />
                        </ListItemIcon>
                        <ListItemText primary={'About'} />
                    </ListItemButton> */}
                    <ListItemButton onClick={handleNavigate(routes.ROUTEABOUT2)}>
                        <ListItemIcon>
                            <AboutIcon />
                        </ListItemIcon>
                        <ListItemText primary={'About'} />
                    </ListItemButton>
                </List>
            </Box>
        </LeftDrawer >
    )
}

export default PublicMenu
